<template>
  <div id="modal1" class="modal modal-work">
    <div class="modal-head">
      <h4>Ajouter un travail</h4>
    </div>
    <div class="modal-content">
      <form class="new-homework">
        <div class="row">
          <div class="input-field">
            <i class="material-icons-outlined prefix">label</i>
            <textarea
              id="label"
              class="materialize-textarea validate"
              v-model="newWork.label"
            ></textarea>
            <label :class="newWork.label.length > 0 ? 'active' : ''" for="label"
              >Intitulé</label
            >
          </div>
        </div>
        <div class="row">
          <div class="input-field">
            <i class="material-icons-outlined prefix">school</i>
            <select
              v-model="newWork.module"
              v-if="modulesByUE != undefined && userProfile != undefined && userProfile['group' + config.semester] != undefined"
            >
              <option value="default" disabled selected>
                &lt; Choisissez une matière /&gt;
              </option>
              <optgroup
                v-for="ueId in Object.keys(modulesByUE)/*.filter((v) =>
                  v.startsWith('ue' + userProfile['group' + config.semester].slice(1).slice(0, 1))
                )*/"
                :key="ueId"
                :label="ueId"
              >
                <option
                  :value="matiere.id"
                  :data-icon="'img/modules/' + matiere.icon + '.svg'"
                  v-for="matiere in modulesByUE[ueId].filter((m) => userProfile['group2'].replace('P', 'p').startsWith(m.group))"
                  :key="matiere.id"
                >
                  {{ matiere.displayId }} -
                  {{ matiere.shortName ? matiere.shortName : matiere.displayName }}
                </option>
              </optgroup>
            </select>
            <label>Matière</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s6">
            <i class="material-icons-outlined prefix">today</i>
            <input
              type="text"
              class="datepicker"
              id="datepicker"
              name="datepicker"
            />
            <label class="active" for="datepicker">Date</label>
          </div>
          <div class="input-field col s6">
            <i class="material-icons-outlined prefix">schedule</i>
            <input
              type="text"
              class="timepicker"
              id="timepicker"
              name="timepicker"
            />
            <label class="active" for="timepicker">Heure</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field">
            <i class="material-icons-outlined prefix">stars</i>
            <select v-model="newWork.notation">
              <option value="default" disabled selected>
                &lt; Choisissez une notation /&gt;
              </option>
              <option value="unknown">Non renseigné</option>
              <option value="graded">Noté</option>
              <option value="notGraded">Non noté</option>
            </select>
            <label>Notation</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field">
            <i class="material-icons-outlined prefix">local_shipping</i>
            <select v-model="newWork.delivery">
              <option value="default" disabled selected>
                &lt; Choisissez un type de remise /&gt;
              </option>
              <option value="noDelivery">Pas de remise</option>
              <option value="handDelivery">Remise en main propre</option>
              <option value="onlineDelivery">Remise en ligne</option>
            </select>
            <label>Remise</label>
          </div>
        </div>
        <div class="row" v-if="newWork.delivery == 'onlineDelivery'">
          <div class="input-field">
            <i class="material-icons-outlined prefix">description</i>
            <input
              id="deliveryName"
              type="text"
              class="validate"
              v-model="newWork.deliveryName"
            />
            <label for="deliveryName">Nom du dépôt</label>
          </div>
        </div>
        <div class="row" v-if="newWork.delivery == 'onlineDelivery'">
          <div class="input-field">
            <i class="material-icons-outlined prefix">link</i>
            <input
              id="link"
              type="text"
              class="validate"
              v-model="newWork.link"
            />
            <label for="link">Lien vers le dépôt</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field">
            <i class="material-icons-outlined prefix">group</i>
            <select v-model="newWork.group">
              <option value="default" disabled selected>
                &lt; Choisissez un groupe /&gt;
              </option>
              <option value="class">Classe entière</option>
              <option value="prime">Groupe Prime</option>
              <option value="seconde">Groupe Seconde</option>
            </select>
            <label>Groupe concerné</label>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat"
        >Annuler</a
      >
      <a
        href="#!"
        class="waves-effect waves-green btn-flat"
        @click="validateModal()"
        >Valider</a
      >
    </div>
  </div>
</template>

<style scoped>
.row .col {
  padding: 0;
}
</style>

<style>
.modal {
  outline: none;
  overflow-x: hidden;
  max-height: 95%;
}

.dropdown-content {
  max-height: 380px;
}

@media only screen and (min-height: 850px) {
  .modal {
    overflow: visible;
  }

  .dropdown-content {
    max-height: 600px;
  }
}

.modal .modal-head h4 {
  padding: 20px;
  margin: 0;
  font-size: 20px;
  background-color: #afdab9;
}

.modal .modal-content {
}
/*
.modal .modal-content {
  padding: 0;
  overflow: hidden;
  overflow: visible;
}

.modal .modal-content h4 {
  padding: 20px;
  margin: 0;
  font-size: 20px;
}

.new-homework {
  margin: 20px;
}

.modal .row .col {
  padding: 0;
}

.modal .row {
  margin-bottom: 0;
}
*/
.modal .new-homework > .row .col.s6 {
  padding: 0 16px;
}

.modal .new-homework > .row .col.s6:first-child {
  padding-left: 0;
}

.modal .new-homework > .row .col.s6:last-child {
  padding-right: 0;
}

.modal.modal-work > .modal-content {
  padding: 6px 24px 0 24px;
}

@media only screen and (max-width: 992px) {
  .modal {
    width: 90%;
  }
}

@media only screen and (min-width: 601px) {
  .timepicker-modal,
  .datepicker-modal {
    width: 90%;
  }
}

.select-wrapper ul li img {
  filter: invert(1);
}
</style>

<script>
import M from "materialize-css";
import { mapState } from "vuex";

export default {
  data() {
    return {
      modalsInstances: null,
      newWork: {
        label: "",
        module: "default",
        notation: "default",
        delivery: "default",
        link: "",
        deliveryName: "",
        group: "default",
      },
      datePickers: null,
      timePickers: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "config", "modulesByUE", "agendaRef"]),
  },
  watch: {
    modulesByUE() {
      if (this.modulesByUE != undefined && this.userProfile != undefined && this.agendaRef != undefined) {
        this.initializeModal();
        setTimeout(function () {
          var elems = document.querySelectorAll("select");
          var instances = M.FormSelect.init(elems);
        }, 200);
      }
    },
    userProfile() {
      if (this.modulesByUE != undefined && this.userProfile != undefined && this.agendaRef != undefined) {
        this.initializeModal();
        setTimeout(function () {
          var elems = document.querySelectorAll("select");
          var instances = M.FormSelect.init(elems);
        }, 200);
      }
    },
  },
  mounted() {
    if (this.modulesByUE != undefined && this.userProfile != undefined && this.agendaRef != undefined) {
      this.initializeModal();
      setTimeout(function () {
        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems);
      }, 200);
    }
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    initializeModal() {
      this.modalsInstances = M.Modal.init(document.querySelectorAll(".modal.modal-work"), {
        startingTop: "5%",
        endingTop: "5%",
      });

      this.datePickers = M.Datepicker.init(
        document.querySelectorAll(".datepicker"),
        {
          format: "dd/mm/yyyy",
          firstDay: 1,
          minDate: new Date("2020-09-07"),
          maxDate: new Date("2021-06-27"),
          yearRange: [2020, 2021],
          events: ["Mon Sep 07 2020"],
          i18n: {
            cancel: "Annuler",
            clear: "Effacer",
            done: "Ok",
            months: [
              "Janvier",
              "Février",
              "Mars",
              "Avril",
              "Mai",
              "Juin",
              "Juillet",
              "Août",
              "Septembre",
              "Octobre",
              "Novembre",
              "Décembre",
            ],
            weekdays: [
              "Dimanche",
              "Lundi",
              "Mardi",
              "Mercredi",
              "Jeudi",
              "Vendredi",
              "Samedi",
            ],
            monthsShort: [
              "Janv.",
              "Févr.",
              "Mars",
              "Avril",
              "Mai",
              "Juin",
              "Juil.",
              "Août",
              "Sept.",
              "Oct.",
              "Nov.",
              "Déc.",
            ],
            weekdaysShort: [
              "Dim.",
              "Lun.",
              "Mar.",
              "Mer.",
              "Jeu.",
              "Ven.",
              "Sam.",
            ],
            weekdaysAbbrev: ["D", "L", "M", "M", "J", "V", "S"],
          },
        }
      );

      this.timePickers = M.Timepicker.init(
        document.querySelectorAll(".timepicker"),
        {
          twelveHour: false,
          defaultTime: "08:15",
          i18n: {
            cancel: "Annuler",
            clear: "Effacer",
            done: "Ok",
          },
        }
      );

      if (this.$route.query.add !== undefined) {
        this.openModal();
        if (this.$route.query.add !== null) {
          this.intitule = this.$route.query.add;
        }
      }
    },
    openModal() {
      this.modalsInstances[0].open();
    },
    validateModal() {
      if (
        this.newWork.label.split("\n").filter((l) => l != "").length > 0 &&
        this.newWork.module != "default" &&
        this.datePickers[0].date != undefined &&
        this.timePickers[0].time != undefined &&
        this.newWork.notation != "default" &&
        this.newWork.delivery != "default" &&
        (this.newWork.delivery != "onlineDelivery" || (this.newWork.link != "" && this.newWork.deliveryName != "")) &&
        this.newWork.group != "default"
      ) {
        var newWorkRef = this.agendaRef.push();
        var newWork = {
          label: this.newWork.label.split("\n").filter((l) => l != ""),
          module: this.newWork.module,
          date: this.formatDate(this.datePickers[0].date),
          time: this.timePickers[0].time,
          notation:
            this.newWork.notation != "unknown" ? this.newWork.notation : "",
          delivery:
            this.newWork.delivery != "noDelivery" ? (this.newWork.delivery == "handDelivery" ? "Remise en main propre" : this.newWork.deliveryName) : "",
          link:
            this.newWork.delivery == "onlineDelivery" ? this.newWork.link : "",
          group: this.newWork.group != "class" ? this.newWork.group : "",
        };
        newWorkRef.set(newWork);
        M.toast({ html: "Devoir ajouté avec succès !" });
        this.modalsInstances[0].close();
        this.clearModal();
        setTimeout(function () {
          var elems = document.querySelectorAll("select");
          var instances = M.FormSelect.init(elems);
        }, 200);
      }
    },
    clearModal() {
      this.newWork.label = "";
      this.newWork.module = "default";
      //this.datePickers[0].date != undefined &&
      //this.timePickers[0].time != undefined &&
      this.newWork.notation = "default";
      this.newWork.delivery = "default";
      this.newWork.deliveryName = "";
      this.newWork.link = "";
      this.newWork.group = "default";
    }
  },
};
</script>